package com.parmartechnologies.communication.ui.conversation.detail

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.rounded.ArrowBack
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.parmartechnologies.communication.core.conversation.viewModel.ConversationViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.message.viewModel.MessageViewModel
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.communication.ui.component.ChatBox
import com.parmartechnologies.communication.ui.message.component.MessageCard
import com.parmartechnologies.core.app.navigation.AppNavigator
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import com.parmartechnologies.core.navigation.BaseNavigator
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.core.network.socket.FriendlySocketClient
import com.parmartechnologies.core.theme.ThemeColor
import kotlin.time.ExperimentalTime

class ConversationDetailsScreen(conversation: Conversation) {
    val selectedConversation = conversation

    @OptIn(ExperimentalTime::class)
    @Composable
    fun content() {
        var user by remember { mutableStateOf(FriendlyUser()) }

        val authViewModel = AuthViewModel()
        val viewModel = MessageViewModel()
        val allMessage = viewModel.allMessage.collectAsState()
        var chatBoxValue by remember { mutableStateOf(TextFieldValue("")) }
        LaunchedEffect(key1 = selectedConversation._id) {
            selectedConversation.Participants?.forEach { participantId ->
                if (participantId != AuthHandler.shared().UserID) {
                    authViewModel.getUserDetails(participantId) { userDetails ->
                        user = userDetails
                    }
                }
            }
            FriendlySocketClient.shared().onNewMessage = {
                viewModel.onNewMessageReceived(conversationId = selectedConversation._id)
            }
            viewModel.retrieve(selectedConversation._id)
        }
        Column(modifier = Modifier.fillMaxSize()) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(54.dp)
            ) {
                Row(
                    modifier = Modifier.fillMaxHeight().fillMaxWidth()
                        .background(Color.Blue),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    IconButton(
                        onClick = {
                            BaseNavigator.shared().onBackPress()
                        },
                        modifier = Modifier
                            .width(50.dp).height(50.dp)
                    ) {
                        Icon(
                            Icons.AutoMirrored.Rounded.ArrowBack,
                            contentDescription = "add new items",
                            tint = Color.White,
                        )
                    }

                    Spacer(modifier = Modifier.weight(1f))
                    Text(
                        modifier = Modifier
                            .wrapContentWidth().height(50.dp).padding(top = 10.dp),
                        text = "Chat",
                        color = Color.White,
                        fontSize = 18.sp,
                        fontWeight = FontWeight.Bold,
                        textAlign = TextAlign.Center,

                        )
                    Spacer(modifier = Modifier.weight(1f))

                }
            }
            Column(modifier = Modifier.fillMaxSize().weight(1.0F)) {
                LazyColumn(
                    reverseLayout = true,
                    modifier = Modifier.fillMaxSize()
                ) {
                    items(count = allMessage.value.count()) { index ->
                        MessageCard(
                            selectedConversation,
                            allMessage.value[index],
                            viewModel,
                            authViewModel
                        ) { selectedConversation ->
//                            navigateTo(
//                                ScreenName.MESSAGE_SCREEN, NavigationParam(conversation = selectedConversation)
//                            )
                        }
                    }
                }
            }

            ChatBox(
                onSendChatClickListener = { content ->
                    viewModel.create(selectedConversation._id, content) { newMessage ->
                        if (newMessage != null) {
                            chatBoxValue = TextFieldValue("")
                        }
                    }
                }, chatBoxValue, onChange = { chatBoxValue = it }
            )
        }
    }

}